"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendErrors = exports.BackendErrorCodes = void 0;
var BackendErrorCodes;
(function (BackendErrorCodes) {
    // GENERIC ERRORS
    BackendErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    // CREDITOR ERRORS
    BackendErrorCodes["CREDITOR_NOT_FOUND"] = "CREDITOR_NOT_FOUND";
    BackendErrorCodes["EMAIL_ALREADY_REGISTERED"] = "EMAIL_ALREADY_REGISTERED";
    BackendErrorCodes["EXTERNAL_CREDITOR_ID_ALREADY_REGISTERED"] = "EXTERNAL_CREDITOR_ID_ALREADY_REGISTERED";
    // USER ERRORS
    BackendErrorCodes["USER_IN_UNEXPECTED_STATE"] = "USER_IN_UNEXPECTED_STATE";
    // CLOSURE ERRORS
    BackendErrorCodes["CLOSURE_NOT_FOUND"] = "CLOSURE_NOT_FOUND";
    BackendErrorCodes["DEPRECATED_ORIGINS_WITH_NEW_ONES"] = "DEPRECATED_ORIGINS_WITH_NEW_ONES";
    // VARIABLES ERRORS
    BackendErrorCodes["INVALID_VARIABLE_DATE_RANGE"] = "INVALID_VARIABLE_DATE_RANGE";
    BackendErrorCodes["VARIABLE_KEY_NOT_DEFINED"] = "VARIABLE_KEY_NOT_DEFINED";
    BackendErrorCodes["DUPLICATED_VARIABLE_COLUMN_NAME"] = "DUPLICATED_VARIABLE_COLUMN_NAME";
    BackendErrorCodes["VARIABLE_TYPE_NOT_FOUND"] = "VARIABLE_TYPE_NOT_FOUND";
    BackendErrorCodes["VARIABLE_TAB_NOT_FOUND"] = "VARIABLE_TAB_NOT_FOUND";
    // CLAIMS ERRORS
    BackendErrorCodes["USER_CLAIM_UPDATE_NOT_ALLOWED"] = "USER_CLAIM_UPDATE_NOT_ALLOWED";
    BackendErrorCodes["INVALID_CLAIM_VALUE"] = "INVALID_CLAIM_VALUE";
    BackendErrorCodes["PARSED_CLAIM_ERROR"] = "PARSED_CLAIM_ERROR";
    BackendErrorCodes["MISSING_CLAIMS"] = "MISSING_CLAIMS";
    BackendErrorCodes["INVALID_CLAIM"] = "INVALID_CLAIM";
    // ADJUSTMENT REQUESTS ERRORS
    BackendErrorCodes["ADJUSTMENT_REQUEST_PREFERENCES_NOT_FOUND"] = "ADJUSTMENT_REQUEST_PREFERENCES_NOT_FOUND";
    BackendErrorCodes["ADJUSTMENT_REQUEST_ALREADY_EVALUATED"] = "ADJUSTMENT_REQUEST_ALREADY_EVALUATED";
    BackendErrorCodes["ADJUSTMENT_REQUEST_NOT_FOUND"] = "ADJUSTMENT_REQUEST_NOT_FOUND";
    BackendErrorCodes["ADJUSTMENT_REQUEST_DATA_CHANGED"] = "ADJUSTMENT_REQUEST_DATA_CHANGED";
    // TAB UPDATED
    BackendErrorCodes["TAB_UPDATED_ALREADY_PROCESSING"] = "TAB_UPDATED_ALREADY_PROCESSING";
    // PERIOD
    BackendErrorCodes["PERIOD_UPDATED_ALREADY_PROCESSING"] = "PERIOD_UPDATED_ALREADY_PROCESSING";
    // PERMISSIONS
    BackendErrorCodes["PERMISSION_PROFILE_NOT_FOUND"] = "PERMISSION_PROFILE_NOT_FOUND";
    BackendErrorCodes["PERMISSION_PROFILE_INVALID_TEAM_IDS"] = "PERMISSION_PROFILE_INVALID_TEAM_IDS";
    BackendErrorCodes["PERMISSION_PROFILE_INVALID_USER_IDS"] = "PERMISSION_PROFILE_INVALID_USER_IDS";
    BackendErrorCodes["PERMISSION_PROFILE_PRIORITIES_REQUEST_DUPLICATED_IDS"] = "PERMISSION_PROFILE_PRIORITIES_REQUEST_DUPLICATED_IDS";
    BackendErrorCodes["PERMISSION_PROFILE_PRIORITIES_REQUEST_DUPLICATED_PRIORITIES"] = "PERMISSION_PROFILE_PRIORITIES_REQUEST_DUPLICATED_PRIORITIES";
    BackendErrorCodes["PERMISSION_PROFILE_PRIORITIES_REQUEST_INVALID_LENGTH"] = "PERMISSION_PROFILE_PRIORITIES_REQUEST_INVALID_LENGTH";
    BackendErrorCodes["DUPLICATED_PERMISSION_PROFILE_IDS"] = "DUPLICATED_PERMISSION_PROFILE_IDS";
    // LOGIN ONBOARDING
    BackendErrorCodes["INVALID_TOKEN_ERROR"] = "INVALID_TOKEN_ERROR";
    BackendErrorCodes["TOKEN_ALREADY_USED_ERROR"] = "TOKEN_ALREADY_USED_ERROR";
    BackendErrorCodes["EMAIL_NOT_FOUND_ERROR"] = "EMAIL_NOT_FOUND_ERROR";
    BackendErrorCodes["OFFICE_NOT_FOUND_ERROR"] = "OFFICE_NOT_FOUND_ERROR";
    BackendErrorCodes["USER_NOT_FOUND_ERROR"] = "USER_NOT_FOUND_ERROR";
    BackendErrorCodes["USER_INACTIVE_ERROR"] = "USER_INACTIVE_ERROR";
    BackendErrorCodes["EMAIL_DOES_NOT_MATCH_ERROR"] = "EMAIL_DOES_NOT_MATCH_ERROR";
    BackendErrorCodes["MUST_BE_A_VALID_EMAIL"] = "MUST_BE_A_VALID_EMAIL";
    BackendErrorCodes["MUST_HAVE_AT_LEAST_8_CHARACTERS"] = "MUST_HAVE_AT_LEAST_8_CHARACTERS";
    BackendErrorCodes["MUST_HAVE_LOWER_CASE_ERROR"] = "MUST_HAVE_LOWER_CASE_ERROR";
    BackendErrorCodes["MUST_HAVE_UPPER_CASE_ERROR"] = "MUST_HAVE_UPPER_CASE_ERROR";
    BackendErrorCodes["MUST_CONTAIN_NUMBER_ERROR"] = "MUST_CONTAIN_NUMBER_ERROR";
    BackendErrorCodes["MUST_CONTAIN_SPECIAL_CHARACTER"] = "MUST_CONTAIN_SPECIAL_CHARACTER";
    BackendErrorCodes["MUST_NOT_HAVE_EMPTY_SPACE_ERROR"] = "MUST_NOT_HAVE_EMPTY_SPACE_ERROR";
    BackendErrorCodes["PASSWORD_DO_NOT_MATCH_ERROR"] = "PASSWORD_DO_NOT_MATCH_ERROR";
    // LAMBDA ERRORS
    BackendErrorCodes["LAMBDA_PAYMENT_REQUEST_ERRORED"] = "LAMBDA_PAYMENT_REQUEST_ERRORED";
    BackendErrorCodes["LAMBDA_CHECKOUT_REQUEST_ERRORED"] = "LAMBDA_CHECKOUT_REQUEST_ERRORED";
    // PAYMENT GROUP ERRORS
    BackendErrorCodes["PAYMENT_GROUP_BULK_COMPANY_NOT_FOUND"] = "PAYMENT_GROUP_BULK_COMPANY_NOT_FOUND";
    BackendErrorCodes["PAYMENT_GROUP_BULK_EXTERNAL_CREDITOR_NOT_FOUND"] = "PAYMENT_GROUP_BULK_EXTERNAL_CREDITOR_NOT_FOUND";
    BackendErrorCodes["PAYMENT_GROUP_BULK_DUPLICATED"] = "PAYMENT_GROUP_BULK_DUPLICATED";
    BackendErrorCodes["PAYMENT_GROUP_DUPLICATED"] = "PAYMENT_GROUP_DUPLICATED";
    BackendErrorCodes["PAYMENT_GROUP_COMPANY_NOT_FOUND"] = "PAYMENT_GROUP_COMPANY_NOT_FOUND";
    BackendErrorCodes["PAYMENT_GROUP_EXTERNAL_CREDITOR_NOT_FOUND"] = "PAYMENT_GROUP_EXTERNAL_CREDITOR_NOT_FOUND";
    BackendErrorCodes["PAYMENT_GROUP_NOT_FOUND"] = "PAYMENT_GROUP_NOT_FOUND";
    // PAYMENT
    BackendErrorCodes["INVALID_PIX_KEY"] = "INVALID_PIX_KEY";
    BackendErrorCodes["CANT_CHOOSE_CREDITOR_NAME"] = "CANT_CHOOSE_CREDITOR_NAME";
    // SECRET
    BackendErrorCodes["PARSE_SECRET_ERROR"] = "PARSE_SECRET_ERROR";
    // CREDITOR PAYMENT INFO ERRORS
    BackendErrorCodes["PAYMENT_INFO_CREDITOR_NOT_FOUND"] = "PAYMENT_INFO_CREDITOR_NOT_FOUND";
    BackendErrorCodes["PAYMENT_INFO_FINANCIAL_INSTITUTION_NOT_FOUND"] = "PAYMENT_INFO_FINANCIAL_INSTITUTION_NOT_FOUND";
    BackendErrorCodes["PAYMENT_INFO_DUPLICATE_CREDITORS_ON_REQUEST"] = "PAYMENT_INFO_DUPLICATE_CREDITORS_ON_REQUEST";
    BackendErrorCodes["PAYMENT_INFO_DEACTIVATING_ON_UPDATE"] = "PAYMENT_INFO_DEACTIVATING_ON_UPDATE";
    BackendErrorCodes["PAYMENT_INFO_NOT_FOUND_BY_EXTERNAL_CREDITOR_ID"] = "PAYMENT_INFO_NOT_FOUND_BY_EXTERNAL_CREDITOR_ID";
    BackendErrorCodes["PAYMENT_INFO_NOT_FOUND_BY_ID"] = "PAYMENT_INFO_NOT_FOUND_BY_ID";
    BackendErrorCodes["PAYMENT_INFO_ACTIVE_ON_DELETE"] = "PAYMENT_INFO_ACTIVE_ON_DELETE";
    BackendErrorCodes["PAYMENT_INFO_INVALID_CHANGELOG_PARAMETERS"] = "PAYMENT_INFO_INVALID_CHANGELOG_PARAMETERS";
    // RESTORE RULES AND LISTS BACKUP
    BackendErrorCodes["RESTORE_RULES_ERROR"] = "RESTORE_RULES_ERROR";
    BackendErrorCodes["RESTORE_RULES_INVALID_VERSION_OR_CLOSURE_DATE_ERROR"] = "RESTORE_RULES_INVALID_VERSION_OR_CLOSURE_DATE_ERROR";
    // RULES
    BackendErrorCodes["RULES_ALREADY_APPLYING"] = "RULES_ALREADY_APPLYING";
    // FILES
    BackendErrorCodes["SPREADSHEET_NOT_FOUND"] = "SPREADSHEET_NOT_FOUND";
    // AWS ERROR
    BackendErrorCodes["AWS_S3_OBJECT_NOT_FOUND"] = "AWS_S3_OBJECT_NOT_FOUND";
    // DOCUMENT ERROR
    BackendErrorCodes["DOCUMENT_FORBIDDEN_APPROVAL_EVALUATION"] = "DOCUMENT_FORBIDDEN_APPROVAL_EVALUATION";
    BackendErrorCodes["DOCUMENT_FORBIDDEN_MARK_AS_PAID"] = "DOCUMENT_FORBIDDEN_MARK_AS_PAID";
    BackendErrorCodes["DOCUMENT_CREDITOR_NOT_FOUND"] = "DOCUMENT_CREDITOR_NOT_FOUND";
    BackendErrorCodes["CANNOT_CREATE_PAYROLL_DOC_WITHOUT_PAYROLL_DATA"] = "CANNOT_CREATE_PAYROLL_DOC_WITHOUT_PAYROLL_DATA";
    BackendErrorCodes["DOCUMENT_SOURCE_NOT_SUPPORTED"] = "DOCUMENT_SOURCE_NOT_SUPPORTED";
    BackendErrorCodes["CANNOT_CREATE_PLAN_DOC_WITHOUT_PERIOD_ID"] = "CANNOT_CREATE_PLAN_DOC_WITHOUT_PERIOD_ID";
    BackendErrorCodes["CANNOT_CREATE_PAYMENT_REQUEST_DOC_WITHOUT_PAYROLL_DATA"] = "CANNOT_CREATE_PAYMENT_REQUEST_DOC_WITHOUT_PAYROLL_DATA";
    // BULK ERRORS
    BackendErrorCodes["DUPLICATED_EMAIL_ON_REQUEST"] = "DUPLICATED_EMAIL_ON_REQUEST";
    BackendErrorCodes["PROFILE_NOT_FOUND"] = "PROFILE_NOT_FOUND";
    // CLOSURE COMMISSION BACKUP EVENTS
    BackendErrorCodes["LOCK_ALREADY_EXIST"] = "LOCK_ALREADY_EXIST";
    BackendErrorCodes["LOCK_NOT_EXIST"] = "LOCK_NOT_EXIST";
    BackendErrorCodes["INVALID_LOCK_METADATA"] = "INVALID_LOCK_METADATA";
    BackendErrorCodes["EVENT_IS_ALREADY_BEING_PROCCESSED"] = "EVENT_IS_ALREADY_BEING_PROCCESSED";
    // PAYROLL
    BackendErrorCodes["PAYROLL_NOT_FOUND"] = "PAYROLL_NOT_FOUND";
    BackendErrorCodes["PAYROLL_DATA_DUPLICATED"] = "PAYROLL_DATA_DUPLICATED";
    BackendErrorCodes["PAYROLL_DATA_NOT_FOUND"] = "PAYROLL_DATA_NOT_FOUND";
    BackendErrorCodes["PAYROLL_DATA_STATUS_UPDATE_LENGTH_MISTAKE"] = "PAYROLL_DATA_STATUS_UPDATE_LENGTH_MISTAKE";
    BackendErrorCodes["INVALID_HASH_ON_THE_FLY"] = "INVALID_HASH_ON_THE_FLY";
    BackendErrorCodes["PAYROLL_OPTION_NOT_FOUND"] = "PAYROLL_OPTION_NOT_FOUND";
    BackendErrorCodes["MORE_THAN_ONE_PAYROLL_OPTION"] = "MORE_THAN_ONE_PAYROLL_OPTION";
    BackendErrorCodes["INCONSISTENT_PAYMENT_CHECKOUT_DATA"] = "INCONSISTENT_PAYMENT_CHECKOUT_DATA";
    BackendErrorCodes["INVALID_CREDITOR_PAYMENT_INFO"] = "INVALID_CREDITOR_PAYMENT_INFO";
    BackendErrorCodes["PAYROLL_NOT_VISIBLE"] = "PAYROLL_NOT_VISIBLE";
    BackendErrorCodes["PAYROLL_CONFIG_NOT_FOUND"] = "PAYROLL_CONFIG_NOT_FOUND";
    BackendErrorCodes["STATUS_NORMALIZATION_MUST_BE_PROVIDE"] = "STATUS_NORMALIZATION_MUST_BE_PROVIDE";
    BackendErrorCodes["STATUS_NORMALIZATION_NOT_FOUND"] = "STATUS_NORMALIZATION_NOT_FOUND";
    // LOGIN
    BackendErrorCodes["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
    // USER MANAGEMENT CLAIM
    BackendErrorCodes["USER_MANAGEMENT_NOT_ALLOWED_DELETE"] = "USER_MANAGEMENT_NOT_ALLOWED_DELETE";
    BackendErrorCodes["USER_MANAGEMENT_NOT_ALLOWED_CREATE"] = "USER_MANAGEMENT_NOT_ALLOWED_CREATE";
    // OUTBOUND WEBHOOKS
    BackendErrorCodes["OUTBOUND_WEBHOOK_NOT_FOUND"] = "OUTBOUND_WEBHOOK_NOT_FOUND";
    BackendErrorCodes["OUTBOUND_WEBHOOK_INVALID_CONTEXT"] = "OUTBOUND_WEBHOOK_INVALID_CONTEXT";
    BackendErrorCodes["OUTBOUND_WEBHOOK_ERROR_WITH_TEMPLATE"] = "OUTBOUND_WEBHOOK_ERROR_WITH_TEMPLATE";
    BackendErrorCodes["OUTBOUND_WEBHOOK_DATA_NOT_FOUND"] = "OUTBOUND_WEBHOOK_DATA_NOT_FOUND";
    BackendErrorCodes["API_XP_NOT_FOUND_COMMISSIONS"] = "API_XP_NOT_FOUND_COMMISSIONS";
    // PAYMENT_REQUEST
    BackendErrorCodes["CREATE_PAYMENT_REQUEST_CREDITOR_MISMATCH"] = "CREATE_PAYMENT_REQUEST_CREDITOR_MISMATCH";
    BackendErrorCodes["CREATE_PAYMENT_REQUEST_METADATA_MISMATCH"] = "CREATE_PAYMENT_REQUEST_METADATA_MISMATCH";
    BackendErrorCodes["CREATE_PAYMENT_REQUEST_AMOUNT_MISMATCH"] = "CREATE_PAYMENT_REQUEST_AMOUNT_MISMATCH";
    BackendErrorCodes["CREATE_PAYMENT_REQUEST_DATA_INVALID_OR_DUPLICATED"] = "CREATE_PAYMENT_REQUEST_DATA_INVALID_OR_DUPLICATED";
    BackendErrorCodes["CANCEL_PAYMENT_REQUEST_ALREADY_CANCELED"] = "PAYMENT_REQUEST_ALREADY_CANCELED";
    BackendErrorCodes["CANCEL_PAYMENT_REQUEST_IN_FINAL_STATUS"] = "CANCEL_PAYMENT_REQUEST_IN_FINAL_STATUS";
    BackendErrorCodes["PAYMENT_REQUEST_CONFIG_NOT_FOUND"] = "PAYMENT_REQUEST_CONFIG_NOT_FOUND";
    BackendErrorCodes["PAYMENT_REQUEST_NOT_FOUND"] = "PAYMENT_REQUEST_NOT_FOUND";
    BackendErrorCodes["PAYROLL_LOCK_ALREADY_EXISTS"] = "PAYROLL_LOCK_ALREADY_EXISTS";
    BackendErrorCodes["PAYMENT_REQUEST_ERROR_CALLING_EVALUATOR"] = "PAYMENT_REQUEST_ERROR_CALLING_EVALUATOR";
    BackendErrorCodes["PAYMENT_REQUEST_INVALID_INPUTS"] = "PAYMENT_REQUEST_INVALID_INPUTS";
    BackendErrorCodes["PAYMENT_REQUEST_CREDITOR_NOT_ALLOWED"] = "PAYMENT_REQUEST_CREDITOR_NOT_ALLOWED";
    BackendErrorCodes["PAYMENT_REQUEST_INPUT_INSERTION_NOT_ALLOWED"] = "PAYMENT_REQUEST_INPUT_INSERTION_NOT_ALLOWED";
    BackendErrorCodes["PAYMENT_REQUEST_INVALID_STATUS"] = "PAYMENT_REQUEST_INVALID_STATUS";
})(BackendErrorCodes = exports.BackendErrorCodes || (exports.BackendErrorCodes = {}));
;
const ApiXpErrors = {
    [BackendErrorCodes.API_XP_NOT_FOUND_COMMISSIONS]: {
        status: 404,
        description: 'Planilha não liberada pela XP, aguarde a liberação',
        data: ['escritorio_xp', 'codigo_master', 'mes', 'ano'],
    },
};
const UserManagementErrors = {
    [BackendErrorCodes.USER_MANAGEMENT_NOT_ALLOWED_DELETE]: {
        status: 403,
        description: 'Você não tem permissão para excluir usuários',
        data: ['claim'],
    },
    [BackendErrorCodes.USER_MANAGEMENT_NOT_ALLOWED_CREATE]: {
        status: 403,
        description: 'Você não tem permissão para criar usuários',
        data: ['claim'],
    },
};
const ClosureEvents = {
    [BackendErrorCodes.LOCK_ALREADY_EXIST]: {
        status: 400,
        description: 'Tem algum processo sendo executado neste fechamento, por favor aguarde',
        data: ['lock_id', 'lock_metadata'],
    },
    [BackendErrorCodes.LOCK_NOT_EXIST]: {
        status: 202,
        description: 'Lock não existe, descartando evento',
        data: ['lock_id'],
    },
    [BackendErrorCodes.INVALID_LOCK_METADATA]: {
        status: 202,
        description: 'Lock metadata inválido, descartando evento',
        data: ['lock_id', 'lock_metadata'],
    },
    [BackendErrorCodes.EVENT_IS_ALREADY_BEING_PROCCESSED]: {
        status: 202,
        description: 'Evento já está sendo processado...',
        data: ['lock_id', 'lock_metadata'],
    },
};
const AwsErrors = {
    [BackendErrorCodes.AWS_S3_OBJECT_NOT_FOUND]: {
        status: 404,
        description: 'Arquivo não encontrado ou indisponível',
        data: [],
    },
};
const FileErrors = {
    [BackendErrorCodes.SPREADSHEET_NOT_FOUND]: {
        status: 404,
        description: 'Ops, planilha não encontrada',
        data: [],
    },
};
const RestoreRulesErrors = {
    [BackendErrorCodes.RESTORE_RULES_ERROR]: {
        status: 400,
        description: 'Erro ao restaurar backup de preferencias de regras e listas, suas configurações não foram alteradas',
        data: [],
    },
    [BackendErrorCodes.RESTORE_RULES_INVALID_VERSION_OR_CLOSURE_DATE_ERROR]: {
        status: 400,
        description: 'Não foi encontrada a versão do backup passada na lista de backups do mês {backup_closure_date} ',
        data: ['backup_closure_date', 'version'],
    },
};
const PaymentInfoErrors = {
    [BackendErrorCodes.PAYMENT_INFO_CREDITOR_NOT_FOUND]: {
        status: 400,
        description: 'Informação de pagamento não encontrada: {external_creditor_id}',
        data: ['external_creditor_id'],
    },
    [BackendErrorCodes.PAYMENT_INFO_FINANCIAL_INSTITUTION_NOT_FOUND]: {
        status: 400,
        description: 'Instituição financeira não encontrada {bank_code}',
        data: ['bank_code'],
    },
    [BackendErrorCodes.PAYMENT_INFO_DUPLICATE_CREDITORS_ON_REQUEST]: {
        status: 400,
        description: 'Não são permitidos usuários duplicados {duplicate_creditors} na mesma requisição',
        data: ['duplicate_creditors'],
    },
    [BackendErrorCodes.PAYMENT_INFO_DEACTIVATING_ON_UPDATE]: {
        status: 409,
        description: 'Desative a informação de pagamento de um usuário ativando outra',
        data: [''],
    },
    [BackendErrorCodes.PAYMENT_INFO_NOT_FOUND_BY_EXTERNAL_CREDITOR_ID]: {
        status: 404,
        description: 'Informação de pagamento do usuário {external_creditor_id} não encontrada',
        data: ['external_creditor_id'],
    },
    [BackendErrorCodes.PAYMENT_INFO_NOT_FOUND_BY_ID]: {
        status: 404,
        description: 'Informação de pagamento do usuário não encontrada',
        data: [''],
    },
    [BackendErrorCodes.PAYMENT_INFO_ACTIVE_ON_DELETE]: {
        status: 409,
        description: 'A informação de pagamento do usuário está ativa. Ative outra informação de pagamento antes de excluir esta',
        data: [''],
    },
    [BackendErrorCodes.PAYMENT_INFO_INVALID_CHANGELOG_PARAMETERS]: {
        status: 500,
        description: 'Parâmetros inválidos para o método addChangeLog',
        data: [''],
    },
};
const SecretErrors = {
    [BackendErrorCodes.PARSE_SECRET_ERROR]: {
        status: 400,
        description: 'Dados inválidos na secret {pretty_name}',
        data: ['pretty_name'],
    },
};
const PaymentErrors = {
    [BackendErrorCodes.INVALID_PIX_KEY]: {
        status: 400,
        description: 'Na informação de pagamento do usuário {creditor}, o valor {pix_key} não é uma chave pix válida',
        data: ['creditor', 'pix_key'],
    },
    [BackendErrorCodes.CANT_CHOOSE_CREDITOR_NAME]: {
        status: 400,
        description: 'É obrigatório ter um nome na informações de pagamento',
        data: [],
    },
};
const PaymentGroupRequestErrors = {
    [BackendErrorCodes.PAYMENT_GROUP_BULK_COMPANY_NOT_FOUND]: {
        status: 404,
        description: 'Empresa não encontrada {company_id} na linha {index}',
        data: ['company_id', 'index'],
    },
    [BackendErrorCodes.PAYMENT_GROUP_BULK_EXTERNAL_CREDITOR_NOT_FOUND]: {
        status: 404,
        description: 'Id do usuário externo incorreto {external_creditor_id} na linha {index}',
        data: ['external_creditor_id', 'index'],
    },
    [BackendErrorCodes.PAYMENT_GROUP_BULK_DUPLICATED]: {
        status: 400,
        description: 'Configuração de grupo de pagamento já existente na linha {index}',
        data: ['duplicated_payment_group', 'index'],
    },
    [BackendErrorCodes.PAYMENT_GROUP_COMPANY_NOT_FOUND]: {
        status: 404,
        description: 'Empresa não encontrada {company_id}',
        data: ['company_id'],
    },
    [BackendErrorCodes.PAYMENT_GROUP_EXTERNAL_CREDITOR_NOT_FOUND]: {
        status: 404,
        description: 'Id do usuário externo incorreto {external_creditor_id}',
        data: ['external_creditor_id'],
    },
    [BackendErrorCodes.PAYMENT_GROUP_DUPLICATED]: {
        status: 400,
        description: 'Configuração de grupo de pagamento já existente',
        data: ['duplicated_payment_group'],
    },
    [BackendErrorCodes.PAYMENT_GROUP_NOT_FOUND]: {
        status: 404,
        description: 'Grupo de pagamento não encontrado',
        data: ['payment_group_id'],
    },
};
const LambdaPaymentRequestErrors = {
    [BackendErrorCodes.LAMBDA_PAYMENT_REQUEST_ERRORED]: {
        status: 400,
        description: 'Ops, erro ao gerar informações de pagamentos para a empresa: {company_name}',
        data: ['company_name', 'errors'],
    },
};
const LambdaCheckoutRequestErrors = {
    [BackendErrorCodes.LAMBDA_CHECKOUT_REQUEST_ERRORED]: {
        status: 400,
        description: 'Erro ao processar o checkout de pagamento',
        data: ['payment_batch_key', 'errors'],
    },
};
const BulkErrors = {
    [BackendErrorCodes.DUPLICATED_EMAIL_ON_REQUEST]: {
        status: 400,
        description: 'Não são permitidos emails duplicados {duplicated_emails} na mesma requisição',
        data: ['duplicated_emails'],
    },
    [BackendErrorCodes.PROFILE_NOT_FOUND]: {
        status: 400,
        description: 'Perfil com o nome {profile_name} não encontrado',
        data: ['profile_name'],
    },
};
const PermissionProfileErrors = {
    [BackendErrorCodes.PERMISSION_PROFILE_NOT_FOUND]: {
        status: 404,
        description: 'permission profile not found',
        data: ['permission_profile_id'],
    },
    [BackendErrorCodes.PERMISSION_PROFILE_INVALID_TEAM_IDS]: {
        status: 400,
        description: 'invalid team_ids payload to put permissions',
        data: ['team_ids'],
    },
    [BackendErrorCodes.PERMISSION_PROFILE_INVALID_USER_IDS]: {
        status: 400,
        description: 'invalid user_ids payload to put permissions',
        data: ['user_ids'],
    },
    [BackendErrorCodes.PERMISSION_PROFILE_PRIORITIES_REQUEST_DUPLICATED_IDS]: {
        status: 400,
        description: 'invalid payload to patch priorities because duplicated ids in array',
        data: ['payload'],
    },
    [BackendErrorCodes.PERMISSION_PROFILE_PRIORITIES_REQUEST_DUPLICATED_PRIORITIES]: {
        status: 400,
        description: 'invalid payload to patch priorities because duplicated priorities in array',
        data: ['payload'],
    },
    [BackendErrorCodes.PERMISSION_PROFILE_PRIORITIES_REQUEST_INVALID_LENGTH]: {
        status: 400,
        description: 'invalid payload to patch priorities because invalid payload lenght',
        data: ['payload'],
    },
    [BackendErrorCodes.DUPLICATED_PERMISSION_PROFILE_IDS]: {
        status: 400,
        description: 'duplicated permission profile ids',
        data: ['permission_profile_ids'],
    },
};
const GenericErrors = {
    [BackendErrorCodes.INTERNAL_SERVER_ERROR]: {
        status: 500,
        description: 'internal server error',
        data: [],
    },
};
const CreditorErrors = {
    [BackendErrorCodes.CREDITOR_NOT_FOUND]: {
        status: 404,
        description: 'creditor not found',
        data: ['external_creditor_id'],
    },
    [BackendErrorCodes.EMAIL_ALREADY_REGISTERED]: {
        status: 409,
        description: 'Já existe um usuário cadastrado com esse email',
        data: ['email', 'external_creditor_id'],
    },
    [BackendErrorCodes.EXTERNAL_CREDITOR_ID_ALREADY_REGISTERED]: {
        status: 409,
        description: 'external creditor id already registered',
        data: ['external_creditor_id'],
    },
};
const UserErrors = {
    [BackendErrorCodes.USER_IN_UNEXPECTED_STATE]: {
        status: 500,
        description: 'Usuário se encontra em um estado inesperado. Por favor, entre em contato com o suporte',
        data: ['external_creditor_id', 'motivo'],
    },
};
const ClosureErrors = {
    [BackendErrorCodes.CLOSURE_NOT_FOUND]: {
        status: 404,
        description: 'closure not found',
        data: ['closure_date'],
    },
    [BackendErrorCodes.DEPRECATED_ORIGINS_WITH_NEW_ONES]: {
        status: 400,
        description: 'start_date must be before end_date',
        data: ['usedOldOrigins', 'usedNewOrigins'],
    },
    [BackendErrorCodes.RULES_ALREADY_APPLYING]: {
        status: 423,
        description: 'uma aplicação de regras está em andamento, aguarde um pouquinho',
        data: ['closure_date'],
    },
};
const VariablesErrors = {
    [BackendErrorCodes.INVALID_VARIABLE_DATE_RANGE]: {
        status: 400,
        description: 'start_date must be before end_date',
        data: ['position', 'target', 'start_date', 'end_date', 'variables'],
    },
    [BackendErrorCodes.VARIABLE_KEY_NOT_DEFINED]: {
        status: 400,
        description: 'variable not defined on columns',
        data: ['key', 'columns'],
    },
    [BackendErrorCodes.DUPLICATED_VARIABLE_COLUMN_NAME]: {
        status: 400,
        description: 'duplicated variable column name on columns list',
        data: ['position', 'columns'],
    },
    [BackendErrorCodes.VARIABLE_TYPE_NOT_FOUND]: {
        status: 400,
        description: 'variable not found',
        data: ['type', 'id'],
    },
    [BackendErrorCodes.VARIABLE_TAB_NOT_FOUND]: {
        status: 400,
        description: 'variable tab not found',
        data: ['type', 'id'],
    },
};
const ClaimErrors = {
    [BackendErrorCodes.USER_CLAIM_UPDATE_NOT_ALLOWED]: {
        status: 403,
        description: 'the received claim type is not allowed to be updated',
        data: ['claim_type'],
    },
    [BackendErrorCodes.INVALID_CLAIM_VALUE]: {
        status: 400,
        description: 'received claim value doesnt match received claim type',
        data: ['claim_type', 'claim_value'],
    },
    [BackendErrorCodes.PARSED_CLAIM_ERROR]: {
        status: 403,
        description: 'received claim value doesnt parsed in claim type',
        data: ['claim_type', 'claim_value'],
    },
    [BackendErrorCodes.MISSING_CLAIMS]: {
        status: 400,
        description: 'all allowed claims must be present',
        data: ['received_claims', 'allowed_claims'],
    },
    [BackendErrorCodes.INVALID_CLAIM]: {
        status: 400,
        description: 'invalid claim',
        data: ['received_claim'],
    },
};
const AdjustmentRequestErrors = {
    [BackendErrorCodes.ADJUSTMENT_REQUEST_PREFERENCES_NOT_FOUND]: {
        status: 404,
        description: 'adjustment request preferences not found',
        data: ['closure_date'],
    },
    [BackendErrorCodes.ADJUSTMENT_REQUEST_ALREADY_EVALUATED]: {
        status: 400,
        description: 'received adjustment requests were already approved and cannot be changed',
        data: ['adjustment_requests'],
    },
    [BackendErrorCodes.ADJUSTMENT_REQUEST_NOT_FOUND]: {
        status: 404,
        description: 'adjustment request not found (by id). Data may be stale',
        data: ['not_found_requests'],
    },
    [BackendErrorCodes.ADJUSTMENT_REQUEST_DATA_CHANGED]: {
        status: 400,
        description: 'evaluated adjustment request data has changed. Data may be stale',
        data: ['divergent_found_requests'],
    },
};
const TabUpdatedErrors = {
    [BackendErrorCodes.TAB_UPDATED_ALREADY_PROCESSING]: {
        status: 202,
        description: 'tab updated already processing. ignoring message',
        data: ['job_id', 'tab_id'],
    },
};
const PeriodUpdatedErrors = {
    [BackendErrorCodes.PERIOD_UPDATED_ALREADY_PROCESSING]: {
        status: 202,
        description: 'period updated already processing. ignoring message',
        data: ['job_id', 'message'],
    },
};
const LoginOnboardingErrors = {
    [BackendErrorCodes.EMAIL_DOES_NOT_MATCH_ERROR]: {
        status: 400,
        description: 'E-mail não corresponde',
        data: ['invitationToken'],
    },
    [BackendErrorCodes.EMAIL_NOT_FOUND_ERROR]: {
        status: 400,
        description: 'E-mail não encontrado',
        data: ['invitationToken'],
    },
    [BackendErrorCodes.INVALID_TOKEN_ERROR]: {
        status: 401,
        description: 'O token fornecido está inválido ou já expirou',
        data: ['invitationToken'],
    },
    [BackendErrorCodes.TOKEN_ALREADY_USED_ERROR]: {
        status: 401,
        description: 'O token fornecido já foi utilizado',
        data: ['invitationToken'],
    },
    [BackendErrorCodes.MUST_BE_A_VALID_EMAIL]: {
        status: 400,
        description: 'Email deve ser um email valido',
        data: ['email'],
    },
    [BackendErrorCodes.MUST_HAVE_AT_LEAST_8_CHARACTERS]: {
        status: 400,
        description: 'Senha deve conter pelo menos 8 caracteres',
        data: ['new_password'],
    },
    [BackendErrorCodes.MUST_CONTAIN_NUMBER_ERROR]: {
        status: 400,
        description: 'Senha deve conter pelo menos um número',
        data: ['new_password'],
    },
    [BackendErrorCodes.MUST_CONTAIN_SPECIAL_CHARACTER]: {
        status: 400,
        description: 'Senha deve conter pelo menos um caractere especial',
        data: ['new_password'],
    },
    [BackendErrorCodes.MUST_HAVE_LOWER_CASE_ERROR]: {
        status: 400,
        description: 'Senha deve conter pelo menos uma lestra minuscula',
        data: ['new_password'],
    },
    [BackendErrorCodes.MUST_HAVE_UPPER_CASE_ERROR]: {
        status: 400,
        description: 'Senha deve conter pelo menos uma lestra maiúscula',
        data: ['new_password'],
    },
    [BackendErrorCodes.MUST_NOT_HAVE_EMPTY_SPACE_ERROR]: {
        status: 400,
        description: 'Senha não pode começar ou terminar com espaços',
        data: ['new_password'],
    },
    [BackendErrorCodes.OFFICE_NOT_FOUND_ERROR]: {
        status: 400,
        description: 'Escritório não encontrado',
        data: ['invitationToken'],
    },
    [BackendErrorCodes.PASSWORD_DO_NOT_MATCH_ERROR]: {
        status: 400,
        description: 'Senhas não correspondem',
        data: ['confirm_password'],
    },
    [BackendErrorCodes.USER_INACTIVE_ERROR]: {
        status: 403,
        description: 'Usuário está inativo',
        data: ['invitationToken'],
    },
    [BackendErrorCodes.USER_NOT_FOUND_ERROR]: {
        status: 400,
        description: 'Usuário não encontrado',
        data: ['invitationToken'],
    },
};
const DocumentErrors = {
    [BackendErrorCodes.DOCUMENT_FORBIDDEN_APPROVAL_EVALUATION]: {
        status: 403,
        description: 'Usuário sem permissão para avaliar o documento.',
        data: ['permission', 'approve'],
    },
    [BackendErrorCodes.DOCUMENT_FORBIDDEN_MARK_AS_PAID]: {
        status: 403,
        description: 'Usuário sem permissão para definir como pago.',
        data: ['permission', 'mark_as_paid'],
    },
    [BackendErrorCodes.DOCUMENT_CREDITOR_NOT_FOUND]: {
        status: 404,
        description: 'Usuário {external_creditor_id} não encontrado',
        data: ['external_creditor_id'],
    },
    [BackendErrorCodes.DOCUMENT_SOURCE_NOT_SUPPORTED]: {
        status: 400,
        description: 'A Origem do documento não é suportada',
        data: ['source'],
    },
    [BackendErrorCodes.CANNOT_CREATE_PAYROLL_DOC_WITHOUT_PAYROLL_DATA]: {
        status: 400,
        description: 'Ocorreu um erro ao subir o documento em um pagamento',
        data: [],
    },
    [BackendErrorCodes.CANNOT_CREATE_PLAN_DOC_WITHOUT_PERIOD_ID]: {
        status: 400,
        description: 'Ocorreu um erro ao subir o documento no plano de cálculo',
        data: [],
    },
    [BackendErrorCodes.CANNOT_CREATE_PAYMENT_REQUEST_DOC_WITHOUT_PAYROLL_DATA]: {
        status: 400,
        description: 'Ocorreu um erro ao subir o documento no pedido de pagamento',
        data: [],
    },
};
const PayrollErrors = {
    [BackendErrorCodes.PAYROLL_NOT_FOUND]: {
        status: 404,
        description: 'Folha de pagamentos nao encontrada',
        data: ['payroll_id'],
    },
    [BackendErrorCodes.PAYROLL_DATA_DUPLICATED]: {
        status: 400,
        description: 'Dados da folha de pagamentos estão duplicados',
        data: ['payroll_data_id'],
    },
    [BackendErrorCodes.PAYROLL_DATA_NOT_FOUND]: {
        status: 400,
        description: 'Dados da folha de pagamentos não encontrado',
        data: [],
    },
    [BackendErrorCodes.PAYROLL_OPTION_NOT_FOUND]: {
        status: 404,
        description: 'Opção de folha de pagamento não encontrada.',
        data: [],
    },
    [BackendErrorCodes.MORE_THAN_ONE_PAYROLL_OPTION]: {
        status: 400,
        description: 'Mais de uma opção de folha de pagamento fornecida.',
        data: [],
    },
    [BackendErrorCodes.INCONSISTENT_PAYMENT_CHECKOUT_DATA]: {
        status: 400,
        description: 'Alguns dados não foram encontrados para realizar o checkout.',
        data: ['receiver_id', 'payroll_id', 'category', 'amount'],
    },
    [BackendErrorCodes.INVALID_CREDITOR_PAYMENT_INFO]: {
        status: 400,
        description: 'Dados de pagamento do credor precisa ser pix ou conta',
        data: ['creditor_id'],
    },
    [BackendErrorCodes.PAYROLL_DATA_STATUS_UPDATE_LENGTH_MISTAKE]: {
        status: 400,
        description: 'Dados inválidos para atualização do status da folha de pagamento',
        data: [],
    },
    [BackendErrorCodes.INVALID_HASH_ON_THE_FLY]: {
        status: 400,
        description: 'Parece que esta folha de pagamentos já foi atualizada.',
        data: ['hash'],
    },
    [BackendErrorCodes.PAYROLL_NOT_VISIBLE]: {
        status: 400,
        description: 'Folha de pagamento não está visível',
        data: ['payroll_id'],
    },
    [BackendErrorCodes.PAYROLL_CONFIG_NOT_FOUND]: {
        status: 404,
        description: 'Configuração da folha de pagamentos não foi encontrada',
        data: ['payroll_config_id'],
    },
    [BackendErrorCodes.STATUS_NORMALIZATION_MUST_BE_PROVIDE]: {
        status: 400,
        description: 'A normalização de status deve ser fornecida para essa configuração',
        data: [],
    },
    [BackendErrorCodes.STATUS_NORMALIZATION_NOT_FOUND]: {
        status: 400,
        description: 'A normalização de status deve ser fornecida para essa configuração',
        data: ['old_status', 'new_status'],
    },
};
const LoginErrors = {
    [BackendErrorCodes.AUTHENTICATION_FAILED]: {
        status: 401,
        description: 'Credenciais inválidas',
        data: [],
    },
};
const OutboundWebhookErrors = {
    [BackendErrorCodes.OUTBOUND_WEBHOOK_NOT_FOUND]: {
        status: 404,
        description: 'Webhook não encontrado',
        data: ['webhook_id', 'client_id'],
    },
    [BackendErrorCodes.OUTBOUND_WEBHOOK_INVALID_CONTEXT]: {
        status: 400,
        description: 'Contexto inválido, verifique o contexto enviado',
        data: ['payload', 'context_schema'],
    },
    [BackendErrorCodes.OUTBOUND_WEBHOOK_ERROR_WITH_TEMPLATE]: {
        status: 400,
        description: 'Erro ao renderizar o template do webhook',
        data: ['context', 'template'],
    },
    [BackendErrorCodes.OUTBOUND_WEBHOOK_DATA_NOT_FOUND]: {
        status: 404,
        description: 'Webhook data não encontrada',
        data: ['webhook_data_id', 'client_id'],
    },
};
const PaymentRequestErrors = {
    [BackendErrorCodes.CREATE_PAYMENT_REQUEST_CREDITOR_MISMATCH]: {
        status: 400,
        description: 'creditor_id deve ser o mesmo em todos os payroll_data',
        data: [],
    },
    [BackendErrorCodes.CREATE_PAYMENT_REQUEST_METADATA_MISMATCH]: {
        status: 400,
        description: 'metadata deve ser a mesma em todos os payroll_data',
        data: [],
    },
    [BackendErrorCodes.CREATE_PAYMENT_REQUEST_AMOUNT_MISMATCH]: {
        status: 409,
        description: 'O valor do amount é divergente em algum payroll_data',
        data: [],
    },
    [BackendErrorCodes.CREATE_PAYMENT_REQUEST_DATA_INVALID_OR_DUPLICATED]: {
        status: 409,
        description: 'O pedido possui payroll_data inexistente, em estado inválido ou duplicado',
        data: [],
    },
    [BackendErrorCodes.CANCEL_PAYMENT_REQUEST_ALREADY_CANCELED]: {
        status: 400,
        description: 'O pedido já está cancelado',
        data: [],
    },
    [BackendErrorCodes.CANCEL_PAYMENT_REQUEST_IN_FINAL_STATUS]: {
        status: 400,
        description: 'Não é possível cancelar um pedido em um estado final',
        data: [],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_CONFIG_NOT_FOUND]: {
        status: 404,
        description: 'Não foi possível encontrar nenhuma configuração de PAYMENT_REQUEST para o escritório',
        data: [],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_NOT_FOUND]: {
        status: 404,
        description: 'Não foi possível encontrar o PAYMENT_REQUEST',
        data: [],
    },
    [BackendErrorCodes.PAYROLL_LOCK_ALREADY_EXISTS]: {
        status: 409,
        description: 'A folha está sendo reprocessada em outro processo',
        data: [],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_ERROR_CALLING_EVALUATOR]: {
        status: 422,
        description: 'Não foi possível avaliar as restrições para mudança de status',
        data: [],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_INVALID_INPUTS]: {
        status: 400,
        description: 'Os dados enviados não correspondem aos dados esperados',
        data: ['errors'],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_CREDITOR_NOT_ALLOWED]: {
        status: 403,
        description: 'Somente o criador do pedido pode realizar essa ação',
        data: [],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_INPUT_INSERTION_NOT_ALLOWED]: {
        status: 400,
        description: 'Não é possível inserir inputs com o pedido no status atual',
        data: [],
    },
    [BackendErrorCodes.PAYMENT_REQUEST_INVALID_STATUS]: {
        status: 400,
        description: 'Não é possível alterar o status para o solicitado',
        data: [],
    },
};
exports.BackendErrors = {
    ...GenericErrors,
    ...CreditorErrors,
    ...UserErrors,
    ...ClosureErrors,
    ...VariablesErrors,
    ...ClaimErrors,
    ...AdjustmentRequestErrors,
    ...TabUpdatedErrors,
    ...PeriodUpdatedErrors,
    ...PermissionProfileErrors,
    ...LoginOnboardingErrors,
    ...LambdaPaymentRequestErrors,
    ...LambdaCheckoutRequestErrors,
    ...PaymentGroupRequestErrors,
    ...SecretErrors,
    ...PaymentErrors,
    ...PaymentInfoErrors,
    ...RestoreRulesErrors,
    ...FileErrors,
    ...AwsErrors,
    ...DocumentErrors,
    ...BulkErrors,
    ...ClosureEvents,
    ...PayrollErrors,
    ...LoginErrors,
    ...UserManagementErrors,
    ...OutboundWebhookErrors,
    ...ApiXpErrors,
    ...PaymentRequestErrors,
};
